class Modal {
	constructor() {
		this.overlay = document.getElementById('modal-overlay');
		this.content = document.getElementById('modal-inner');
		this.isOpen = false;

		if (!this.overlay || !this.content) {
			console.error('Modal elements not found');
			return;
		}

		this.overlay.addEventListener('click', (e) => {
			if (e.target === this.overlay) {
				this.close();
			}
		});

		document.addEventListener('keydown', (e) => {
			if (this.isOpen && e.key === 'Escape') {
				this.close();
			}
		});
	}

	open() {
		this.overlay.classList.remove('hidden');
		this.isOpen = true;
	}

	close() {
		this.overlay.classList.add('hidden');
		this.isOpen = false;
		this.clear();
	}

	setContent(html) {
		this.content.innerHTML = html;
	}

	clear() {
		this.content.innerHTML = '';
	}

	openModal(selector) {
		const el = 	document.querySelector(selector);

		if (!el) {
			return;
		}

		this.setContent(el.innerHTML);
		this.open();
	}
}

window.myModal = new Modal();
